(() => {
  if (window.__nekoRelatedSwatchesBound) return;
  window.__nekoRelatedSwatchesBound = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('product-recommendations [data-neko-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('.card-wrapper') || swatch.closest('.card');
    if (!card) return;

    const group = swatch.closest('[data-neko-card-swatches]') || swatch.parentElement;
    if (group) {
      group.querySelectorAll('[data-neko-card-swatch]').forEach((button) => {
        button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
      });
    }

    const variantUrl = swatch.dataset.variantUrl;
    if (variantUrl) {
      card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        link.href = variantUrl;
      });
    }

    const image = card.querySelector('.card__media img');
    if (image && swatch.dataset.imageSrc) {
      image.src = swatch.dataset.imageSrc;
      if (swatch.dataset.imageSrcset) {
        image.srcset = swatch.dataset.imageSrcset;
      } else {
        image.removeAttribute('srcset');
      }
      if (swatch.dataset.imageAlt) image.alt = swatch.dataset.imageAlt;
    }
  });
})();
